// extracted by mini-css-extract-plugin
export default {"WarningMessage":"InputErrorMessage_WarningMessage__IFMDG","warningLogo":"InputErrorMessage_warningLogo__9eJSf"};